module.exports = __webpack_public_path__ + "img/scissors-cut-02.3f5a314b.svg";